module.exports = __webpack_public_path__ + "img/SOV Report_old.821be5cb.svg";